// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { BYPASS_AUTH } from './../app/services/auth.interceptor';
import { HttpContext } from '@angular/common/http';

export const environment = {
  firebase: {
    apiKey: "AIzaSyCsf_UgAhq-t4p3Vth4zB9CsQLF7Icz9qY",
    authDomain: "autenticacion-sms-a623f.firebaseapp.com",
    databaseURL: "https://autenticacion-sms-a623f-default-rtdb.firebaseio.com",
    projectId: "autenticacion-sms-a623f",
    storageBucket: "autenticacion-sms-a623f.appspot.com",
    messagingSenderId: "781449257626",
    appId: "1:781449257626:web:45c11e37c7491532733523",
    measurementId: "G-133PTD8LDD"
  },
  production: false,
   apiBase: 'https://appws.apa.org.py/servicios',
  httpCtx: {
    SKIP_AUTH: () => new HttpContext().set(BYPASS_AUTH, true),
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
